import { useSearchParams } from "react-router-dom";
import ListState from "../../../../../components/ListState/ListState";
import { useAppSelector } from "../../../../../hooks/useRedux";
import { useFetchSuperviseesCaseload } from "../../../../providers/hooks/providers.queries";
import SuperviseeCaseloadItem from "./SuperviseeCaseloadItem/SuperviseeCaseloadItem";
import { useDebounce } from "../../../../../hooks/helpers";
import Loader from "../../../../../shared-ui/Loader/Loader";

export default function SuperviseeCaseloadList() {
    const [searchParams] = useSearchParams();
    const { practice } = useAppSelector((state) => state.userPractice);

    const searchFilter = searchParams.get("search") || "";
    const filter = searchParams.get("filter");

    const debouncedSearchFilter = useDebounce(searchFilter);

    const { data, isLoading, error, isSuccess } = useFetchSuperviseesCaseload({
        providerId: practice?.provider_id || "",
        search_string: debouncedSearchFilter,
        show_paused_client: "false",
        show_clients_with_pending_tasks:
            filter === "clients_with_pending_task" ? "true" : "",
    });

    return (
        <div>
            {isLoading ? <Loader /> : null}
            {error ? (
                <ListState
                    isError
                    errorMsg={
                        error?.response?.data?.message ||
                        "Could not load supervisee's caseload at this time"
                    }
                    stateHelperText="Try reloading this page to solve this issue"
                    context="general"
                />
            ) : null}
            {isSuccess && data.data.length === 0 ? (
                <ListState
                    stateHelperText="No supervisee's caseload found"
                    isError={false}
                    emptyMessage="No supervisee's caseload"
                    context="general"
                />
            ) : null}
            {isSuccess && data.data.length > 0 ? (
                <div className="flex flex-col gap-y-[--spacing-items]">
                    {data.data.map((item) => (
                        <SuperviseeCaseloadItem
                            details={item}
                            key={item.provider_id}
                        />
                    ))}
                </div>
            ) : null}
        </div>
    );
}
